import { Link } from 'react-router'
import { api } from '../api/client.js'
import { useApi } from '../api/useApi.js'
import SoonButton from './SoonButton.jsx'

/** A donation CTA: a real link once Stripe is configured, "coming soon" until then. */
export default function DonateButton({ kind = 'one_off', feeder, className, children }) {
  const { data } = useApi(() => api.donationConfig())
  if (!data?.enabled) return <SoonButton className={className}>{children}</SoonButton>
  const params = new URLSearchParams({ kind, ...(feeder ? { feeder } : {}) })
  return (
    <Link to={`/donate?${params}`} className={`no-underline ${className}`}>
      {children}
    </Link>
  )
}
